export const STRAPI_BLOG_REST_BATCH_LIMIT = 100;
export const RELEVANT_BLOG_POSTS_PAGE_SIZE = 3;
